module.exports = {
    CLASS_BODY: 'body',
    CLASS_BLOG_SEARCH_WRAPPER: '.js-blog_search',
    CLASS_BLOG_SEARCH_INPUT: '.js-blog_search_input',
    CLASS_BLOG_SEARCH_FORM: '.js-blog_search_form'
};